/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Lead_Get_5Inputs */

const en_cp_lead_get_5 = /** @type {(inputs: Cp_Lead_Get_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiered certificate and a written recommendation from the Penggerak tier`)
};

const id_cp_lead_get_5 = /** @type {(inputs: Cp_Lead_Get_5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sertifikat per tier dan rekomendasi tertulis mulai tier Penggerak`)
};

/**
* | output |
* | --- |
* | "Tiered certificate and a written recommendation from the Penggerak tier" |
*
* @param {Cp_Lead_Get_5Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_lead_get_5 = /** @type {((inputs?: Cp_Lead_Get_5Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Lead_Get_5Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_lead_get_5(inputs)
	return en_cp_lead_get_5(inputs)
});